import Excel from "exceljs";
import _ from "lodash";
import moment from "moment";
export default function extractEmployeeDiscount(e, discountMonth = "") {
  return new Promise((resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.readAsArrayBuffer(file);
    const sheet1Row = [];
    const sheet2Row = {
      discount_month: discountMonth,
      quota: 0,
      msg: "",
      cut_off_date: null,
      cut_off_time: null,
    };
    //1 = product_id
    //5 = backoffice price
    //7 = backoffice price
    //8 = remark
    //9 = Quota
    //10 = active status

    reader.onload = () => {
      const buffer = reader.result;
      wb.xlsx.load(buffer).then((workBook) => {
        workBook.eachSheet((sheet, sheetIndex) => {
          if (sheetIndex === 1) {
            sheet.eachRow((row, rowIndex) => {
              if (rowIndex > 1) {
                if (row.values.length == 0) {
                  reject(`Sheet${sheetIndex} 請上載正確EXCEL`);
                } else {
                  console.log("row.values", row.values);
                  if (
                    (typeof row.values[6] === "object" &&
                      !_.isNumber(row.values[6].result)) ||
                    (typeof row.values[6] !== "object" &&
                      !_.isNumber(row.values[6]))
                  ) {
                    reject(`Sheet${sheetIndex} F${rowIndex} 不是有效數值`);
                  }
                  if (
                    (typeof row.values[8] === "object" &&
                      !_.isNumber(row.values[8].result)) ||
                    (typeof row.values[8] !== "object" &&
                      !_.isNumber(row.values[8]))
                  ) {
                    reject(`Sheet${sheetIndex} H${rowIndex} 不是有效數值`);
                  }
                  if (row.values[10] && !_.isNumber(row.values[10])) {
                    reject(`Sheet${sheetIndex} I${rowIndex} 不是有效數值`);
                  }
                  if (
                    (typeof row.values[11] === "object" &&
                      !_.isBoolean(row.values[11].result)) ||
                    (typeof row.values[11] !== "object" &&
                      !_.isBoolean(row.values[11]))
                  ) {
                    reject(`Sheet${sheetIndex} J${rowIndex} 不是有效數值`);
                  }

                  sheet1Row.push({
                    product_master_id: row.values[1]?.result ?? row.values[1],
                    product_discount_price:
                      row.values[6]?.result?.toFixed(2) ??
                      row.values[6].toFixed(2),
                    promoter_product_discount_price:
                      row.values[8]?.result?.toFixed(2) ??
                      row.values[8].toFixed(2),
                    remark: row.values[9]?.result ?? row.values[9],
                    item_quota: row.values[10]?.result ?? row.values[10],
                    is_active: row.values[11]?.result ?? row.values[11],
                  });
                }
              }
            });
          } else if (sheetIndex === 2) {
            sheet.eachRow((_, rowIndex) => {
              let cell = sheet.getCell(`B${rowIndex}`).value;
              if (rowIndex > 1) {
                if (
                  rowIndex !== 2 &&
                  rowIndex !== 3 &&
                  !sheet.getCell(`B${rowIndex}`).value
                ) {
                  reject(`Sheet${sheetIndex} 請上載正確EXCEL`);
                } else {
                  switch (rowIndex) {
                    //quota
                    case 2:
                      const isNotNum = isNaN(
                        sheet.getCell(`B${rowIndex}`).value
                      );
                      cell &&
                        isNotNum &&
                        reject(`Sheet${sheetIndex} B${rowIndex}值不是有效數值`);
                      sheet2Row.quota = cell;
                      break;
                    //Msg
                    case 3:
                      sheet2Row.msg = cell ?? "";
                      break;
                    case 4:
                      const isDate = moment(cell, "YYYY-MM-DD", true).isValid();
                      if (!isDate) {
                        reject(
                          `Sheet${sheetIndex} B${rowIndex}值不是有效日期格式`
                        );
                      } else if (
                        moment(cell, "YYYY_MM_DD").isSameOrBefore(
                          moment(),
                          "day"
                        )
                      ) {
                        reject(
                          `Sheet${sheetIndex} B${rowIndex}值必須要遲於今日日期`
                        );
                      } else {
                        sheet2Row.cut_off_date = moment(
                          cell,
                          "YYYY-MM-DD"
                        ).format("YYYY-MM-DD");
                      }
                      break;
                    case 5:
                      const isTime = moment(cell, "HH:mm", true).isValid();
                      if (!isTime) {
                        reject(`Sheet${sheetIndex} B${rowIndex}值不是有效時間`);
                      } else {
                        sheet2Row.cut_off_time = moment(cell, "HH:mm").format(
                          "HH:mm"
                        );
                      }
                      break;
                    default:
                      break;
                  }
                }
              }
            });
          }
        });
        const sheets = {
          sheet1: sheet1Row,
          sheet2: sheet2Row,
        };
        resolve(sheets);
      });
    };
  });
}
